import styled from 'styled-components';
import { Atom } from 'AppReact';

const template = styled.img`
  width: 40px;
  height: 40px;
  padding: 12px;
  border-radius: 50%;
  object-fit: contain;
  background-color: #F3F5F5;
  margin-right: 12px;
`;

export default Atom({ type: 'image', dataType: 'string', template });